import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import BackgroundPage from 'src/components/BackgroundPage/BackgroundPage'
import NotFoundBottomContent from 'src/components/NotFoundBottomContent/NotFoundBottomContent'
import NotFoundTopContent from 'src/components/NotFoundTopContent/NotFoundTopContent'
import { css } from 'styled-components'

interface NotFoundBackgroundPageProps {
  className?: string
}

const NotFoundBackgroundPage: React.FC<NotFoundBackgroundPageProps> = (
  props,
): React.ReactElement => {
  return (
    <BackgroundPage className={props.className}>
      <div
        css={css`
          display: flex;
          justify-content: center;
          background-color: ${styleConstants.colors.white};
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
          z-index: 1;
          padding: 40px 75px 60px;

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            padding: 30px 75px;
          `)}
        `}
      >
        <NotFoundTopContent />
      </div>
      <div
        css={css`
          flex-grow: 2;
          display: flex;
          justify-content: center;
          background-color: ${styleConstants.colors.gray_lightest};
          padding: 60px 0px;

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            padding: 30px 75px;
          `)}
        `}
      >
        <NotFoundBottomContent />
      </div>
    </BackgroundPage>
  )
}

export default NotFoundBackgroundPage
